/** API route map: URLS.Controller.BankAccount */
export const BankAccount = {
      Name: 'BankAccount/',
      GetAllBankAccount: 'get-all',
      AddBankAccount: 'add-bank-account',
      UpdateBankAccount: 'update-bank-account',
      DeleteBankAccount: 'delete-bank-account',
      PatchBankAccount: 'patch-bank-account',
};
